///* eslint-disable no-undef */
//// Axios/AxiosInstance.js
//import axios from 'axios';
//import { getToken } from "../Auth/Auth";
//import { handleAxiosError} from '../ErrorHandler/errorHandler';
////https://coderscratchpad.com/handling-http-status-codes-with-axios/
//const AxiosInstance = axios.create({
//    //*** Set Axios Default BaseURl
//      //baseURL:'https://localhost:7248', // Base URL for local API calls
//      baseURL: 'https://bhuhit.com/api', // Base URL for server API calls
//      timeout:20000, // Timeout for requests
//});cd
//// Add a request interceptor
//AxiosInstance.interceptors.request.use(
//    (config) => {


//        //const token = "eGuru123$";//localStorage.getItem('token');
//        //if (token) {
//        //    config.headers.Authorization = `Bearer ${token}`; // Attach token to requests
//        //}
//        const token = getToken();
//        if (token) config.headers.Authorization = `Bearer ${token}`;
//        return config;
//    },
//    (error) => {
//        return ""; //Promise.reject(error);
//    }
//);

//// Add a response interceptor// Interceptors in Axios allow you to modify requests and responses
//// before they are handled by then or catch.
//// This feature is useful for implementing global error handling and logging.
//AxiosInstance.interceptors.response.use(
//    response => response,
//    async error => {
//        if (error.response) {
//          //  alert(error.code+"hjkjk");
//            if (error.code === 'ECONNABORTED') {
//                console.log('Request timed out');
//            } else if (error.code === 'ENOTFOUND') {
//                console.log('Server not found');
//            } else {
//                console.log('Network error:', error.message);
//            }
//            switch (error.response.status) {
//                case 400:
//                   //2025-06-25 handleAxiosError(error, "AxiosInstance.js", "Case 400(" + error.config.url +")");
//                    console.log('Bad Request:', error.response.data);
//                    console.log("Bad Request: The server could not understand the request due to invalid syntax.")
//                    break;
//                case 401:
//                   //2025-06-25 handleAxiosError(error, "AxiosInstance.js", "Case 401(" + error.config.url +")");
//                    console.log('Unauthorized:', error.response.data);
//                    console.log("Unauthorized: The client must authenticate itself to get the requested response.")
//                    break;
//                case 403:
//                   //2025-06-25 handleAxiosError(error, "AxiosInstance.js", "Case 403(" + error.config.url +")");
//                    console.log('Forbidden:', error.response.data);
//                    console.log("Forbidden: The client does not have access rights to the content.")
//                    break;
//                case 404:
//                   //2025-06-25 handleAxiosError(error, "AxiosInstance.js", "Case 404("+error.config.url+")");
//                    console.log('Not Found:', error.message);
//                    console.log("Not Found: The server cannot find the requested resource.")
//                    break;
//                case 500:
//                   //2025-06-25 handleAxiosError(error, "AxiosInstance.js", "Case 500(" + error.config.url +")");
//                    console.log('Internal Server Error:', error.response.data);
//                    console.log("Internal Server Error: The server encountered an unexpected condition that prevented it from fulfilling the request.")
//                    break;
//                default:
//                    //2025-06-25 handleAxiosError(error, "AxiosInstance.js", "Case default()");
//                    console.log('Error:', error.response.data);
//            }
//        }
//        return "";// --Promise.reject(error);
//    }
//);
//export default AxiosInstance;



/* eslint-disable no-undef */
// Axios/AxiosInstance.js
import axios from 'axios';
import { getToken } from "../Auth/Auth";
// handleAxiosError import removed — all calls are commented out (no-unused-vars)

const AxiosInstance = axios.create({
            //baseURL: 'https://localhost:7248', // local
            baseURL: 'https://bhuhit.com/api',   // server
         timeout: 60000,
    // FIX 1: removed stray 'cd' that appeared after '});' on the original line —
    // it was treated as a bare expression statement, causing the
    // ESLint no-unused-expressions error on line 12.
});

// ── Request interceptor — attach JWT token ───────────────────────
AxiosInstance.interceptors.request.use(
    (config) => {
        const token = getToken();
        if (token) config.headers.Authorization = `Bearer ${token}`;
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// ── Response interceptor — global error handling ─────────────────
AxiosInstance.interceptors.response.use(
    response => response,
    async error => {
        if (error.response) {
            if (error.code === 'ECONNABORTED') {
                console.log('Request timed out');
            } else if (error.code === 'ENOTFOUND') {
                console.log('Server not found');
            } else {
                console.log('Network error:', error.message);
            }

            // FIX 2: replaced all [error.response.data](http://error.response.data)
            // with plain error.response.data — those were markdown hyperlink
            // syntax accidentally pasted into JS, which is invalid and causes
            // a parse/runtime error.
            switch (error.response.status) {
                case 400:
                    // handleAxiosError(error, "AxiosInstance.js", "Case 400(" + error.config.url +")");
                    console.log('Bad Request:', error.response.data);
                    console.log("Bad Request: The server could not understand the request due to invalid syntax.");
                    break;
                case 401:
                    // handleAxiosError(error, "AxiosInstance.js", "Case 401(" + error.config.url +")");
                    console.log('Unauthorized:', error.response.data);
                    console.log("Unauthorized: The client must authenticate itself to get the requested response.");
                    break;
                case 403:
                    // handleAxiosError(error, "AxiosInstance.js", "Case 403(" + error.config.url +")");
                    console.log('Forbidden:', error.response.data);
                    console.log("Forbidden: The client does not have access rights to the content.");
                    break;
                case 404:
                    // handleAxiosError(error, "AxiosInstance.js", "Case 404(" + error.config.url + ")");
                    console.log('Not Found:', error.message);
                    console.log("Not Found: The server cannot find the requested resource.");
                    break;
                case 500:
                    // handleAxiosError(error, "AxiosInstance.js", "Case 500(" + error.config.url +")");
                    console.log('Internal Server Error:', error.response.data);
                    console.log("Internal Server Error: The server encountered an unexpected condition.");
                    break;
                default:
                    // handleAxiosError(error, "AxiosInstance.js", "Case default()");
                    console.log('Error:', error.response.data);
            }
        }
        return Promise.reject(error);
    }
);

export default AxiosInstance;

